import {Component} from '@angular/core';
import {GeneralSymbolsEncodingComponent} from '../general-symbol-encoding/g-symbols-encoding.component';

@Component({
  selector: 'app-symbols-encoding-equal-or-not',
  templateUrl: './symbols-encoding-equal-or-not.component.html',
  styleUrls: ['./symbols-encoding-equal-or-not.component.css']
})
export class SymbolsEncodingEqualOrNotComponent extends GeneralSymbolsEncodingComponent {

  lastCounterDifferences = 0;

  generateRandomExercise() {
    this.initValues();
    const numberOfEncodings = this.getNumberOfEncodings();

    this.generateCoding(numberOfEncodings);

    this.encodings = this.generalEncoding;
    this.currentEncodingChange.emit(this.generalEncoding);
  }

  /**
   * Returns the number of words that we want to encode
   */
  getNumberOfEncodings() {
    return 2;
  }

  /**
   * Returns the length of all the encodings.
   * The number of symbols an encodings consist of.
   */
  getEncodingLength() {
    if (this.level === 1) {
      return 3;
    }  else if (this.level === 2) {
      return 4;
    } else {
      return 5;
    }
  }

  generateCoding(numberOfEncodings: number) {
    const length = this.getEncodingLength();
    const randCountDifferences = this.getCounterDifferences(length);
    const encoding1 = [];
    const encoding2 = [];

    const indexOfDifferences = this.getUniqueIndexes(0, length, randCountDifferences);

    for (let i = 0; i < length; i++) {
      const randSymbol1 = Math.floor((Math.random() * 2));
      encoding1.push(randSymbol1);
      if (indexOfDifferences.indexOf(i) === -1) {
        encoding2.push(randSymbol1);
      } else {
        if (randSymbol1 === 0) {
          encoding2.push(1);
        } else {
          encoding2.push(0);
        }
      }

    }

    this.generalEncoding = [encoding1, encoding2];
  }

  getCounterDifferences(length: number) {
    let counterDifferences = Math.floor((Math.random() * (length + 1)));

    if (this.lastCounterDifferences === 0) {
      while (counterDifferences === 0) {
        counterDifferences = Math.floor((Math.random() * (length + 1)));
      }
    }
    this.lastCounterDifferences = counterDifferences;
    return counterDifferences;
  }
}
